import { render, staticRenderFns } from "./JDListItem.vue?vue&type=template&id=ebcac250&scoped=true&"
import script from "./JDListItem.vue?vue&type=script&lang=js&"
export * from "./JDListItem.vue?vue&type=script&lang=js&"
import style0 from "./JDListItem.vue?vue&type=style&index=0&id=ebcac250&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebcac250",
  null
  
)

export default component.exports